const state = {
  outPageUrl: ''
}

const getters = {
  outPageUrl: state => state.outPageUrl
}

const actions = {
  setOutPageUrl ({ commit }, data) {
    commit('setOutPageUrl', data)
  }
}

const mutations = {
  setOutPageUrl (state, data) {
    state.outPageUrl = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/out_page.js